import styled from 'styled-components'

export const Asterisk = styled.span`
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.lightRed};
`
